class SpecificationItem {
  constructor(dto) {
    this.slug = dto.slug;
    this.name = dto.name;
    this.isInteractive = dto.isInteractive;
    this.option = dto.option;
  }

  getName() {
    return getLocalizedName(this.name);
  }

  getValue() {
    return getLocalizedName(this.option.value);
  }

  getLink() {
    return `${this.slug}=${this.option.slug}`;
  }
}

export class Specification {
  constructor(dto) {
    this.group = dto.group;
    this.items = dto.items.map((dtoItem) => new SpecificationItem(dtoItem));
  }

  getGroupName() {
    if (null === this.group) {
      return _T("@General specifications");
    }

    return getLocalizedName(this.group);
  }
}
